import { useLocation, useNavigate, useParams } from "react-router-dom";

import axios from 'axios';
import Storages from '../helper/storages'
import useEndpoints from "../api/useEndpoints";
import errorHandler from "../api/errorHandler";
import { useState, useRef, useEffect } from "react";

import Toast from './toast'
import paths from '../config/paths.json'

import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai'
import Captcha from "./captcha";
import initUserInfo from "../api/initUserInfo";
import LoginHeader from "./loginHeader";
import { fa2En } from '../helper/InputHelper'
import { useMediaQuery } from 'react-responsive'
import toast from "./toast";
import { FaArrowLeft } from 'react-icons/fa';
import AddOriginAddress from "../modals/addOriginAddress";

export default function SaveLocation() {
  const endpoints = useEndpoints();
  const navigate = useNavigate();
  var location = useLocation();
  var params = useParams();
  var bg_sm = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-sm.jpg`)
  var bg_lg = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-lg.jpg`)
  var logo = require(`../assets/images/${process.env.REACT_APP_ENV}/logo.png`)

  const [state, setState] = useState(location.state)
  const [haveLocation, setHaveLocation] = useState(false)
  const [loading, setLoading] = useState(false)
  const [eshCode, setEshCode] = useState()
  const isMobile = useMediaQuery({ query: `(max-width: 767px)` });


  useEffect(() => {
    setEshCode(params.eCode)
    setHaveLocation(true)
  }, [params])






  return (

    <div >

      <div className="d-flex justify-content-center align-items-center  vh-100 overflow-auto bg-danger" style={{ top: 0, right: 0, bottom: 0, left: 0 }} >

        <div className="w-100 vh-100 position-absolute bg-dark align-items-center overflow-hidden  justify-content-center d-flex ">
          {
            isMobile ?
              <img className="center-cropped " src={bg_sm} />
              :
              <img className="  center-cropped " src={bg_lg} />
          }
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center col-10  col-sm-6 col-md-5 col-lg-3   ">
          <div className="card p-3 col-12 " autoComplete="on"  >
            <div className="d-flex w-100 justify-content-center align-items-center trans ">
              <img style={{ width: '9rem' }} className="position-absolute top-0 mt-2 start-50 translate-middle" src={logo} />
            </div>

            <h5 className="justify-content-center align-items-center d-flex iranSansBold mt-5">دریافت موقعیت</h5>

            <div className="form-group pt-2 autocomp">
              <label htmlFor="verifyCode" className="pb-1">کد کاربر را در کادر پایین وارد نمایید</label>
              <input type="number" className="form-control" name="verifyCode" placeholder="کد تایید"
                onKeyDown={(event) => {
                  if (event.key.toLowerCase() == "enter") {
                    setHaveLocation(true)
                    event.preventDefault();

                  }
                }}
                onChange={(e) => {
                  setEshCode(e.target.value)
                }} />
            </div>


            <div>
              <button
                className="btn btn-success iranSansBold col-12 mt-2 arcaptcha"
                onClick={() => {
                  setHaveLocation(true)

                }}
              >ثبت موقعیت </button>
            </div>


          </div>
          <small className="form-text text-white text-shadow " style={{ zIndex: '1000', textShadow: '2px 2px #000000' }}>1401 © توسعه و اجرا توسط شرکت <a href="http://efspco.ir" target="_blank" className="">ابتکار فناوران سهند پویا</a> </small>

        </div>



      </div>
      <AddOriginAddress
        onClose={() => {
          setHaveLocation(false)
        }}
        eshCode={eshCode}
        show={haveLocation}
        onResult={(params) => {
          setHaveLocation(false)
          axios.get(endpoints.saveLocation, { params: { ...params, eshCode } }
          ).then((res) => {
            toast.Success("آدرس با موفقیت تغییر یافت")
          }).catch((e) => {
            errorHandler(e)
          })
        }
        } />
    </div>



  );

}